import React from 'react';
import { Redirect } from 'react-router-dom';
import { routePaths } from '../../routePaths';

const Settings = () => {
    return <Redirect to={routePaths.customPaymentMethodsSettings} />;
};

export default Settings;